import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/images/chevron-up.svg'
import _imports_1 from '@/images/chevron-down.svg'
import _imports_2 from '../../public/logo.svg'


const _withScopeId = n => (_pushScopeId("data-v-baa319a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "relative p-5" }
const _hoisted_2 = {
  key: 0,
  src: _imports_0,
  alt: "open"
}
const _hoisted_3 = {
  key: 1,
  src: _imports_1,
  alt: "close"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "logo",
  class: "mx-auto mb-10"
}, null, -1))
const _hoisted_5 = { class: "relative max-w-2xl mx-auto" }
const _hoisted_6 = ["onSubmit"]
const _hoisted_7 = { class: "mb-6" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "id",
  class: "block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300"
}, "App Id", -1))
const _hoisted_9 = { class: "mb-6" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "key",
  class: "block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300"
}, "App Key", -1))
const _hoisted_11 = { class: "mb-6" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "release",
  class: "block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300"
}, "Release Id", -1))
const _hoisted_13 = { class: "mb-6" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "channel",
  class: "block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300"
}, "Channel Tag", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "!bg-[#EB6D46] !text-black px-5 py-2 rounded-md"
}, " Submit ", -1))
const _hoisted_16 = { class: "overflow-x-auto relative" }
const _hoisted_17 = { class: "w-full text-sm text-left text-gray-500 dark:text-gray-400" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", { class: "text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-3 py-[10px] text-center text-xs font-normal text-gray2 uppercase tracking-wider bg-[#1E1E1E]"
    }, " Asset Tag "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-3 py-[10px] text-center text-xs font-normal text-gray2 uppercase tracking-wider bg-[#1E1E1E]"
    }, " Version Tag "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-3 py-[10px] text-center text-xs font-normal text-gray2 uppercase tracking-wider bg-[#1E1E1E]"
    }, " Published At ")
  ])
], -1))
const _hoisted_19 = {
  scope: "row",
  class: "py-4 px-6 font-medium text-white whitespace-nowrap text-center"
}
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = {
  scope: "row",
  class: "py-4 px-6 font-medium text-white whitespace-nowrap text-center"
}
const _hoisted_23 = {
  scope: "row",
  class: "py-4 px-6 font-medium text-white whitespace-nowrap text-center"
}

import { IonContent, IonHeader, IonPage, onIonViewWillEnter } from '@ionic/vue';
import { ref } from 'vue';
import axios from 'axios';


export default /*#__PURE__*/_defineComponent({
  __name: 'HomePage',
  setup(__props) {

const showForm = ref(false);
const showTable = ref(true);
const appId = ref(process.env.VUE_APP_XAPIS_APP_ID);
const releaseId = ref(process.env.VUE_APP_XAPIS_RELEASE_ID);
const channelId = ref(process.env.VUE_APP_XAPIS_CHANNEL_TAG);
const appKey = ref(process.env.VUE_APP_XAPIS_APP_KEY);
const allData = ref([]);

onIonViewWillEnter(() => {
  getLatest();
});

function formatDate(date: any) {
  date = new Date();
  let day = `0${date.getDate()}`.slice(-2);
  let month = `0${date.getMonth() + 1}`.slice(-2);
  let year = date.getFullYear();
  return `${year} / ${month} / ${day}`;
}
function formatTime(time: any) {
  var date = new Date();
  time = date.toLocaleTimeString();
  console.log(time);
  return time;
}
function convertText(text: any) {
  return text.toString().replace(/,/g, ' | ');
}
function getLatest() {
  var options = {
    method: 'GET',
    url: `${process.env.VUE_APP_XAPIS_ENDPOINT}/client/app/${appId.value}/release/${releaseId.value}/channel/${channelId.value}/latest`,
    headers: {
      'x-app-key': appKey.value,
    },
  };

  axios
    .request(options)
    .then(function (response) {
      allData.value = response.data.assets;
      showTable.value = true;
    })
    .catch(function (error) {
      alert(error.code);
    });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), { translucent: true }),
      _createVNode(_unref(IonContent), { fullscreen: true }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("button", {
              class: "absolute right-2",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (showForm.value = !showForm.value))
            }, [
              (showForm.value)
                ? (_openBlock(), _createElementBlock("img", _hoisted_2))
                : (_openBlock(), _createElementBlock("img", _hoisted_3))
            ]),
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              (showForm.value)
                ? (_openBlock(), _createElementBlock("form", {
                    key: 0,
                    onSubmit: _withModifiers(getLatest, ["prevent"])
                  }, [
                    _createElementVNode("div", _hoisted_7, [
                      _hoisted_8,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        id: "id",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((appId).value = $event)),
                        class: "appearance-none block bg-transparent w-full h-[38px] px-3 py-2 border border-[#A7A7A7] rounded-md shadow-sm placeholder:text-[#FBFBFB] focus:outline-none focus:ring-0 focus:border-pri focus:border-[1.8px] sm:text-sm hover:shadow-md transition-all mb-[15px];"
                      }, null, 512), [
                        [_vModelText, appId.value]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _hoisted_10,
                      _withDirectives(_createElementVNode("input", {
                        type: "password",
                        id: "key",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((appKey).value = $event)),
                        class: "appearance-none block bg-transparent w-full h-[38px] px-3 py-2 border border-[#A7A7A7] rounded-md shadow-sm placeholder:text-[#FBFBFB] focus:outline-none focus:ring-0 focus:border-pri focus:border-[1.8px] sm:text-sm hover:shadow-md transition-all mb-[15px];"
                      }, null, 512), [
                        [_vModelText, appKey.value]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _hoisted_12,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        id: "release",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((releaseId).value = $event)),
                        class: "appearance-none block bg-transparent w-full h-[38px] px-3 py-2 border border-[#A7A7A7] rounded-md shadow-sm placeholder:text-[#FBFBFB] focus:outline-none focus:ring-0 focus:border-pri focus:border-[1.8px] sm:text-sm hover:shadow-md transition-all mb-[15px];"
                      }, null, 512), [
                        [_vModelText, releaseId.value]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _hoisted_14,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        id: "channel",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((channelId).value = $event)),
                        class: "appearance-none block bg-transparent w-full h-[38px] px-3 py-2 border border-[#A7A7A7] rounded-md shadow-sm placeholder:text-[#FBFBFB] focus:outline-none focus:ring-0 focus:border-pri focus:border-[1.8px] sm:text-sm hover:shadow-md transition-all mb-[15px];"
                      }, null, 512), [
                        [_vModelText, channelId.value]
                      ])
                    ]),
                    _hoisted_15
                  ], 40, _hoisted_6))
                : _createCommentVNode("", true)
            ]),
            (showTable.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["max-w-2xl mx-auto", { 'pt-10' : showForm.value}])
                }, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("table", _hoisted_17, [
                      _hoisted_18,
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allData.value, (data) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            class: "bg-[#272727] border-b border-gray-500",
                            key: data.id
                          }, [
                            _createElementVNode("th", _hoisted_19, [
                              (data.attributes == 0)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_20, "default"))
                                : (_openBlock(), _createElementBlock("p", _hoisted_21, _toDisplayString(convertText(data.attributes)), 1))
                            ]),
                            _createElementVNode("th", _hoisted_22, _toDisplayString(data.versionTag), 1),
                            _createElementVNode("th", _hoisted_23, [
                              _createElementVNode("p", null, _toDisplayString(formatDate(data.publishedAt)), 1),
                              _createElementVNode("p", null, _toDisplayString(formatTime(data.publishedAt)), 1)
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ])
                ], 2))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})